// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wp_a bie_b bie_we"};